module.exports = __webpack_public_path__ + "static/media/donut-icon.405cde90.svg";